module.exports = __webpack_public_path__ + "static/media/assessment-pause.a80699f1.svg";